export default __webpack_public_path__ + "static/media/info-icon.3081c73a.svg";